import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import CreatableSelect from "react-select/creatable";
import { makeStyles } from "@material-ui/core/styles";
import { InputLabel } from "../.."; // const { ValueContainer, Placeholder } = components;
// const CustomValueContainer = ({ children, ...props }) => {
// 	return (
// 		<components.ValueContainer {...props}>
// 			<Placeholder {...props} isFocused={props.isFocused}>
// 				{props.selectProps.placeholder}
// 			</Placeholder>
// 			{React.Children.map(children, (child) => {
// 				return child && child.type !== Placeholder ? child : null;
// 			})}
// 		</components.ValueContainer>
// 	);
// };

var useStyles = makeStyles(function (theme) {
  return {
    formControl: {
      "margin-top": "20px"
    },
    select: {
      "& .Select-menu-outer": {
        zIndex: "100 !important"
      },
      "& .Select-menu": {
        zIndex: "100 !important"
      },
      "& [role=listbox]": {
        zIndex: "100 !important"
      },
      marginTop: "8px"
    }
  };
});

var CreatableSelectSM = function CreatableSelectSM(_ref) {
  var form = _ref.form,
      className = _ref.className,
      field = _ref.field,
      placeholder = _ref.placeholder,
      options = _ref.options,
      isMulti = _ref.isMulti,
      disabled = _ref.disabled,
      label = _ref.label,
      noOptionsMsg = _ref.noOptionsMsg,
      fillForm = _ref.fillForm,
      components = _ref.components,
      defaultValue = _ref.defaultValue,
      handleCreate = _ref.handleCreate,
      createBillingInfo = _ref.createBillingInfo,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["form", "className", "field", "placeholder", "options", "isMulti", "disabled", "label", "noOptionsMsg", "fillForm", "components", "defaultValue", "handleCreate", "createBillingInfo", "variant"]);

  var classes = useStyles(); // console.log("options CreatableSelectSM", options);

  var setValue = function setValue(options) {
    if (isMulti) {
      if (options) {
        return options.map(function (item) {
          return item.value;
        });
      }
    } else return options === null ? "" : options.value;
  };

  var checkBillingInfo = function checkBillingInfo(input) {
    /* Check if the client have all billingInfo complete so it can be billed */
    if (input.billingInfo) {
      var obj = _objectSpread({}, input.billingInfo);

      if (Object.keys(obj).length < 4) return false;else {
        for (var key in obj) {
          if (obj[key] === null || obj[key] === "" || obj[key] === undefined) {
            return false;
          }

          return true;
        }
      }
    } else return false;
  };

  var onChange = function onChange(options) {
    if (variant === "billing" && field.name === "client") {
      // console.log("check", checkBillingInfo(options));
      checkBillingInfo(options) ? form.setFieldValue(field.name, setValue(options)) : createBillingInfo(options);
    }

    form.setFieldValue(field.name, setValue(options));

    if (fillForm) {
      fillForm(options.value);
    }
  };

  var getValue = function getValue() {
    if (options) {
      return isMulti ? options.filter(function (option) {
        if (field.value) {
          return field.value.indexOf(option.value) >= 0;
        }

        return false;
      }) : // options.find((option) => option.value === field.value)
      options.find(function (option) {
        return option.value === field.value;
      });
    } else {
      return isMulti ? [] : "";
    }
  };

  var customStyles = {
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: state.isSelected ? "#33ff99" : "white",
        backgroundColor: "#424242",
        borderBottom: "1px solid hsl(0,0%,80%)",
        padding: "18.5px 14px",
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif'
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: "white"
      });
    },
    indicatorsContainer: function indicatorsContainer(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        height: "40px"
      });
    },
    placeholder: function placeholder() {
      return {
        color: "white"
      };
    },
    input: function input(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: "white"
      });
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        backgroundColor: "#424242",
        border: "1px solid #33ff99 ",
        zIndex: 100
      });
    },
    control: function control(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: "white",
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        backgroundColor: "#424242",
        border: "1px #6e6e6e solid",
        borderRadius: "4px",
        padding: "6px",
        margin: "8px 0px",
        borderColor: state.isFocused ? "yellow" : "green",
        "&:hover": {
          borderColor: "white"
        },
        boxShadow: state.isFocused ? null : null,
        zIndex: 80,
        outline: 0
      });
    },
    noOptionsMessage: function noOptionsMessage(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: "white",
        fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif'
      });
    },
    singleValue: function singleValue(provided, state) {
      var opacity = state.isDisabled ? 0.5 : 1;
      var transition = "opacity 300ms";

      if (state.selectProps.name.includes("tax")) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          opacity: opacity,
          transition: transition,
          background: "grey",
          padding: "5px 20px",
          color: "white",
          borderRadius: "5px",
          // color: '#33ff99',
          fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif'
        });
      } else {
        return _objectSpread(_objectSpread({}, provided), {}, {
          opacity: opacity,
          transition: transition,
          color: "#33ff99",
          fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif'
        });
      }
    }
  };
  return [/*#__PURE__*/React.createElement(InputLabel, {
    key: label,
    className: props.marginTopDisabled ? null : classes.formControl
  }, label), /*#__PURE__*/React.createElement(CreatableSelect, {
    className: [className, classes.select].join(" "),
    name: field.name,
    key: field.name,
    value: getValue(),
    onChange: onChange,
    placeholder: placeholder,
    options: options,
    styles: customStyles,
    isMulti: isMulti,
    isDisabled: disabled,
    isClearable: true,
    isSercheable: true,
    defaultValue: defaultValue,
    onCreateOption: handleCreate,
    noOptionsMessage: function noOptionsMessage() {
      return noOptionsMsg || "No se encontraron resultados";
    } // components={{
    // 	ValueContainer: CustomValueContainer
    // }}

  })];
};

export { CreatableSelectSM };